import { ZEPLogger } from '../logger';

/**
 * 앱별 ZEPLogger 구성을 stable facade에 등록합니다.
 *
 * registerLogger()는 더 이상 runtime state owner를 교체하지 않습니다.
 * 앱이 새 ZEPLogger 인스턴스를 다시 등록하더라도 leaf logger/initialState만 갱신하고,
 * AuthContext/space/map 등에서 이미 주입한 runtime context는 아래 exported logger가 유지합니다.
 *
 * @see packages/logger/src/runtime/facade.ts
 * @see ADR-001 Option C: Composite Root + per-app assembly pattern
 */
export function registerLogger(instance: ZEPLogger): void {
  if (instance === logger) {
    return;
  }

  logger.configure(instance.getConfigurationSnapshot());
}

export const logger = new ZEPLogger({ loggers: [], initialState: {} });
